var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98118 20C15.5127 20 20 15.5243 20 10C20 4.47887 15.5158 0 9.98118 0C4.73503 0 0.426466 4.0313 0 9.15806H13.2393V10.8388H0C0.426466 15.9687 4.73503 20 9.98118 20Z",
    fill: "#0052FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBase);
export default __webpack_public_path__ + "static/media/blue-base.bbdfd5cf11990ffb0fdd1a7ada63748e.svg";
export { ForwardRef as ReactComponent };